import { Modal } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import { connect, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import renderToggleButtonField from "@/shared/components/form/ToggleButton";
import { flashError, flashSuccess } from '../flash';
import axios from 'axios';
import COUNTRIES from "./countryCodes.json";
import Select from 'react-select'
import { useState } from 'react';

const countries = COUNTRIES
    .sort((a, b) => a.name === 'United States' ? -1 : b.name === 'United States' ? 1 : 0)
    .map((country) => ({
        label: <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src={country.image} width="20" height='20' alt={country.name} style={{ borderRadius: '2px', objectFit: 'cover' }} />
            <span>{country.name} <span style={{ color: '#94a3b8' }}>{country.dial_code}</span></span>
        </div>,
        value: country.dial_code,
        ...country
    }))

const NOTIFICATIONS = [
    { name: 'set_password_text_notification',    label: 'Set Password',      desc: 'When your password is set for the first time' },
    { name: 'reset_password_text_notification',  label: 'Password Reset',    desc: 'When a password reset is requested' },
    { name: 'reward_points_text_notification',   label: 'Points Rewarded',   desc: 'When you earn new reward points' },
    { name: 'reward_badge_text_notification',    label: 'Badge Earned',      desc: 'When you receive a new badge' },
    { name: 'code_redemption_text_notification', label: 'Code Redeemed',     desc: 'When a gift code is redeemed' },
];

const TextNotificationsModal = ({ organization, program, user, isOpen, toggle }) => {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const dispatch = useDispatch();

    const filterOption = (option, inputValue) => {
        return (
            (option.value && option?.value.includes(inputValue)) ||
            option.data.name.toLowerCase().includes(inputValue)
        );
    };

    const validate = (values) => {
        let errors = {};
        if (!values.country_code) errors.country_code = t("country_code_is_required");
        if (!values.phone) {
            errors.phone = t("phone_is_required");
        } else if (!/^[0-9]+$/.test(values.phone)) {
            errors.phone = t("invalid_phone_number");
        }
        return errors;
    };

    const onSubmit = ({ phone, country_code, ...values }) => {
        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("phone", phone);
        formData.append("country_code", country_code.value);
        formData.append("first_name", user.first_name);
        formData.append("last_name", user.last_name);
        formData.append("email", user.email);

        axios.post(`/organization/${organization?.id}/user/${user?.id}`, formData)
            .then(() => axios.put(`/organization/${organization?.id}/program/${program?.id}/user/${user.id}/preference`, values))
            .then(() => {
                flashSuccess(dispatch, "Text Notifications added successfully");
                toggle();
                window.location.reload();
            })
            .catch((err) => flashError(dispatch, err.message));
    };

    return (
        <Modal className="phone-prefs-modal" isOpen={isOpen} toggle={toggle}>
            <div className="phone-prefs-modal__inner">

                <div className="phone-prefs-modal__header">
                    <div className="phone-prefs-modal__header-icon" aria-hidden="true">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="phone-prefs-modal__header-text">
                        <h3 className="phone-prefs-modal__title">Phone Preferences</h3>
                        <p className="phone-prefs-modal__subtitle">Manage your number and SMS notifications</p>
                    </div>
                    <button className="phone-prefs-modal__close" onClick={toggle} aria-label="Close">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                            <path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                <Form
                    onSubmit={onSubmit}
                    validate={validate}
                    initialValues={{
                        country_code: user ? countries.find(c => c.value === user.country_code) : countries[0],
                        phone: user?.phone,
                        set_password_text_notification:    user.preference?.set_password_text_notification,
                        reset_password_text_notification:  user.preference?.reset_password_text_notification,
                        reward_points_text_notification:   user.preference?.reward_points_text_notification,
                        reward_badge_text_notification:    user.preference?.reward_badge_text_notification,
                        code_redemption_text_notification: user.preference?.code_redemption_text_notification,
                    }}
                >
                    {({ handleSubmit }) => (
                        <form onSubmit={handleSubmit}>

                            <div className="phone-prefs-modal__body">

                                <section className="phone-prefs-modal__section">
                                    <h4 className="phone-prefs-modal__section-title">Phone Number</h4>
                                    <div className="phone-prefs-modal__phone-row">
                                        <div className="phone-prefs-modal__country">
                                            <Field name="country_code">
                                                {({ input, meta }) => (
                                                    <>
                                                        <Select
                                                            {...input}
                                                            options={countries}
                                                            filterOption={filterOption}
                                                            classNamePrefix="pp-select"
                                                            onMenuOpen={() => setMenuOpen(true)}
                                                            onMenuClose={() => setMenuOpen(false)}
                                                            placeholder="Country"
                                                            styles={{
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    opacity: menuOpen ? 0.4 : 1,
                                                                    transition: 'opacity 0.2s',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    overflow: 'visible',
                                                                }),
                                                            }}
                                                        />
                                                        {meta.touched && meta.error && (
                                                            <span className="phone-prefs-modal__field-error">{meta.error}</span>
                                                        )}
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="phone-prefs-modal__number">
                                            <Field name="phone">
                                                {({ input, meta }) => (
                                                    <>
                                                        <input
                                                            {...input}
                                                            type="text"
                                                            placeholder="Phone number"
                                                            className="phone-prefs-modal__input"
                                                        />
                                                        {meta.touched && meta.error && (
                                                            <span className="phone-prefs-modal__field-error">{meta.error}</span>
                                                        )}
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                    <p className="phone-prefs-modal__hint">You can disable individual notifications at any time.</p>
                                </section>

                                <section className="phone-prefs-modal__section">
                                    <h4 className="phone-prefs-modal__section-title">SMS Notifications</h4>
                                    <div className="phone-prefs-modal__toggles">
                                        {NOTIFICATIONS.map(({ name, label, desc }) => (
                                            <div key={name} className="phone-prefs-modal__toggle-row">
                                                <div className="phone-prefs-modal__toggle-text">
                                                    <span className="phone-prefs-modal__toggle-label">{label}</span>
                                                    <span className="phone-prefs-modal__toggle-desc">{desc}</span>
                                                </div>
                                                <Field name={name} component={renderToggleButtonField} />
                                            </div>
                                        ))}
                                    </div>
                                </section>

                            </div>

                            <div className="phone-prefs-modal__footer">
                                <button type="button" className="phone-prefs-modal__btn phone-prefs-modal__btn--cancel" onClick={toggle}>
                                    Cancel
                                </button>
                                <button type="submit" className="phone-prefs-modal__btn phone-prefs-modal__btn--save">
                                    Save Changes
                                </button>
                            </div>

                        </form>
                    )}
                </Form>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    program: state.program,
    organization: state.organization,
});

export default connect(mapStateToProps)(TextNotificationsModal);
